const ROOT_VALUE = require('../../../config/rem-root-value.js')

export function pxToRem(px) {
  const n = Number(px)
  return `${Math.round((n / ROOT_VALUE) * 1e5) / 1e5}rem`
}

export default pxToRem
